import React from "react";
import logohesaab from "../assets/images/logo.svg";

// Full-page maintenance splash. Deliberately self-contained (no i18n/context
// dependencies) so it can render before those providers mount - see
// utils/maintenanceWindow.js and index.js for the gating logic.
const MaintenancePage = () => (
    <div
        style={{
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            padding: "24px",
            background: "#f7f8f9",
            fontFamily: "inherit",
        }}
    >
        <img src={logohesaab} alt="Hesaab" width={140} style={{ marginBottom: "24px" }} />
        <h2 style={{ fontWeight: 600, marginBottom: "12px" }}>Hesaab is currently under maintenance</h2>
        <p style={{ color: "#6c757d", maxWidth: "420px", fontSize: "1rem" }}>
            We're performing scheduled server maintenance from 10 PM to 1 AM.
            Hesaab will be back online automatically once it's complete.
        </p>
    </div>
);

export default MaintenancePage;
